import React, { Component } from 'react';
import * as echarts from 'echarts';
import bus from '@utils/bus';
import { debounce } from '@utils/tool'
import walden from '@src/services/theme/walden'

export default class LineDiagram extends Component {
    state = {
        echartsBox: null,
        option: {
            // 图表边距优化
            grid: {
                left: '3%',
                right: '4%',
                bottom: '15%',
                top: '15%',
                containLabel: true
            },
            // 图例优化
            legend: {
                type: 'scroll',
                orient: 'horizontal',
                top: '2%',
                left: 'center',
                itemGap: 15,
                itemWidth: 25,
                itemHeight: 14,
                textStyle: {
                    fontSize: 12,
                    color: '#666'
                },
                pageIconColor: '#2f4554',
                pageIconInactiveColor: '#aaa',
                pageIconSize: 12,
                pageTextStyle: {
                    color: '#666'
                },
                formatter: name => {
                    const feilds = this.props.options.feilds;
                    return feilds ? feilds[name] : name;
                }
            },
            // 提示框优化
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(50, 50, 50, 0.9)',
                borderColor: '#333',
                borderWidth: 1,
                padding: [10, 15],
                textStyle: {
                    color: '#fff',
                    fontSize: 13
                },
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999'
                    },
                    lineStyle: {
                        color: '#999',
                        type: 'dashed'
                    },
                    label: {
                        backgroundColor: '#6a7985',
                        fontSize: 12
                    }
                },
                formatter: params => {
                    let template = ``;
                    const feilds = this.props.options.feilds;
                
                    template = `<div style="font-weight: bold; margin-bottom: 8px; padding-bottom: 6px; border-bottom: 1px solid rgba(255,255,255,0.2);">${params[0].axisValue}</div>`;
                    params.forEach(val => {
                        const currentVal = val.value[val.seriesName];
                        if (currentVal !== undefined && currentVal !== null && currentVal !== 0) {
                            // 格式化数值显示
                            const displayVal = typeof currentVal === 'number' 
                                ? (currentVal > 10000 
                                    ? (currentVal / 10000).toFixed(2) + '万' 
                                    : currentVal.toLocaleString())
                                : currentVal;
                            template += `
                                <div style="margin-top: 6px; display: flex; justify-content: space-between; align-items: center;">
                                    <span>${val.marker}${feilds ? (feilds[val.seriesName] || val.seriesName) : val.seriesName}</span>
                                    <span style="margin-left: 20px; font-weight: bold;">${displayVal}</span>
                                </div>
                            `;
                        }
                    });
                    return template;
                }
            },
            // 数据缩放组件
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    xAxisIndex: [0],
                    start: 0,
                    end: 100,
                    bottom: '5%',
                    height: 20,
                    handleSize: '80%',
                    handleStyle: {
                        color: '#5470c6'
                    },
                    textStyle: {
                        color: '#666'
                    },
                    borderColor: '#ddd'
                },
                {
                    type: 'inside',
                    xAxisIndex: [0],
                    start: 0,
                    end: 100
                }
            ],
            dataset: {},
            // X轴优化
            xAxis: { 
                type: 'category',
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: '#999'
                    }
                },
                axisLabel: {
                    color: '#666',
                    fontSize: 12,
                    rotate: 0,
                    interval: 'auto',
                    formatter: (value) => {
                        // 如果是日期格式，可以进行优化显示
                        if (value && value.length > 10) {
                            return value.substring(5, 10);
                        }
                        return value;
                    }
                },
                axisTick: {
                    alignWithLabel: true
                },
                splitLine: {
                    show: false
                }
            },
            // Y轴优化
            yAxis: {
                type: 'value',
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: '#666',
                    fontSize: 12,
                    formatter: (value) => {
                        // 大数值格式化
                        if (value >= 10000) {
                            return (value / 10000).toFixed(1) + '万';
                        }
                        return value;
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#e5e5e5',
                        type: 'dashed'
                    }
                }
            },
            series: []
        }
    };

    componentDidMount() {
        bus.subscribe('echarts_line', this.handleEchartsDataChange);
        bus.subscribe('echarts_resize', this.handleEchartsResize);
        window.addEventListener('resize', debounce(this.handleEchartsResize, 150));
    };

    componentWillUnmount(){
        bus.unSubscribe(['echarts_line', 'echarts_resize'])
        window.removeEventListener('resize', debounce(this.handleEchartsResize, 150));
    };

    handleEchartsDataChange = (id) => {
        if(id && id !== this.props.id){
            return
        }
        console.log('echarts update');
        this.initOption();
        echarts.registerTheme('walden', walden)
        
        // 如果已存在实例，先销毁
        if(this.state.echartsBox) {
            this.state.echartsBox.dispose();
        }
        
        this.setState({
            echartsBox: echarts.init(document.getElementById(this.props.id || 'main'), 'walden')
        }, () => {
            // 添加动画配置
            const optionWithAnimation = {
                ...this.state.option,
                animation: true,
                animationDuration: 1000,
                animationEasing: 'cubicOut'
            };
            this.state.echartsBox.setOption(optionWithAnimation, true);
        });
    };

    handleEchartsResize = () => {
        if(this.state.echartsBox){
            debounce(this.state.echartsBox.resize, 100)()
        }
    }

    initOption() {
        let tempOPtions = this.state.option;

        tempOPtions = this.handleOptions(tempOPtions)

        tempOPtions.dataset = this.props.options.dataset;

        // 根据数据量动态调整 dataZoom
        const dataLength = tempOPtions.dataset.source.length;
        if (dataLength > 30) {
            // 数据量大时，显示缩放条并默认只显示最新的30条数据
            const endPercent = 100;
            const startPercent = Math.max(0, (1 - 30 / dataLength) * 100);
            tempOPtions.dataZoom[0].show = true;
            tempOPtions.dataZoom[0].start = startPercent;
            tempOPtions.dataZoom[0].end = endPercent;
            tempOPtions.dataZoom[1].start = startPercent;
            tempOPtions.dataZoom[1].end = endPercent;
            // 调整 grid 底部边距，为缩放条腾出空间
            tempOPtions.grid.bottom = '15%';
        } else if (dataLength > 15) {
            // 数据量中等时，显示缩放条但展示全部数据
            tempOPtions.dataZoom[0].show = true;
            tempOPtions.dataZoom[0].start = 0;
            tempOPtions.dataZoom[0].end = 100;
            tempOPtions.dataZoom[1].start = 0;
            tempOPtions.dataZoom[1].end = 100;
            tempOPtions.grid.bottom = '15%';
        } else {
            // 数据量少时隐藏缩放条，显示全部数据
            tempOPtions.dataZoom[0].show = false;
            tempOPtions.dataZoom[0].start = 0;
            tempOPtions.dataZoom[0].end = 100;
            tempOPtions.dataZoom[1].start = 0;
            tempOPtions.dataZoom[1].end = 100;
            // 减少底部边距
            tempOPtions.grid.bottom = '10%';
        }

        if(this.props.options.series && this.props.options.series.length){
            this.setState({
                option: tempOPtions
            });
            return
        }

        const len = tempOPtions.dataset.dimensions.length - 1;

        tempOPtions.series = [];
        for (let i = 0; i < len; i++) {
            tempOPtions.series.push({ 
                type: 'line', 
                smooth: true,
                smoothMonotone: 'x',
                symbol: 'circle',
                symbolSize: 6,
                showSymbol: false, // 默认不显示标记点，鼠标悬停时显示
                emphasis: {
                    focus: 'series',
                    scale: true,
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: '#fff',
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.3)'
                    }
                },
                lineStyle: {
                    width: 2
                },
                areaStyle: {
                    opacity: 0.1
                }
            });
        }
        this.setState({
            option: tempOPtions
        });
    };

    handleOptions(options) {
        const optKey = ['legend', 'tooltip', 'xAxis', 'yAxis', 'grid', 'series']
        for(let key in this.props.options){
            if(optKey.indexOf(key) > -1){
                options[key] = this.props.options[key]
            }
        }
        return options
    }

    render() {
        if (this.props.options.dataset.source.length === 0) {
            this.state.echartsBox && this.state.echartsBox.dispose();

            return (
                <div style={{
                    width: '100%', 
                    height: this.props.options.height || '400px', 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#909399',
                    fontSize: '14px'
                }}>
                    <svg 
                        style={{ width: '64px', height: '64px', marginBottom: '16px', opacity: 0.4 }}
                        viewBox="0 0 64 64" 
                        fill="currentColor"
                    >
                        <path d="M57,8H7c-1.1,0-2,0.9-2,2v44c0,1.1,0.9,2,2,2h50c1.1,0,2-0.9,2-2V10C59,8.9,58.1,8,57,8z M55,52H9V12h46V52z"/>
                        <path d="M13,48h4V28h-4V48z M21,48h4V20h-4V48z M29,48h4V32h-4V48z M37,48h4V24h-4V48z M45,48h4V36h-4V48z"/>
                    </svg>
                    <div>暂无数据</div>
                    <div style={{ fontSize: '12px', marginTop: '8px', color: '#C0C4CC' }}>
                        请选择查询条件后点击查询按钮
                    </div>
                </div>
            );
        }

        return (
            <div id={this.props.id || 'main'} style={{width: '100%', height: this.props.options.height || '400px'}}></div>
        );
    }
}   